import {ActionIcon, Flex, Tooltip} from "@mantine/core";
import IconSidebar from "../../../assets/sidebar.svg?react";
import {useTranslation} from "react-i18next";
import {AppContext} from "../AppContext";
import {useContext} from "react";
import {useMediaQuery} from "@mantine/hooks";
import {useExperimentalMode} from "../useExperimentalMode";

export const SidebarToggle = ({
    bgColor,
    color,
}: {
    bgColor?: string;
    color?: string;
}) => {
    const {mobileNavBarOpen, navbarExpanded, toggleNavBar} =
        useContext(AppContext);
    const {t} = useTranslation();
    const isMobile = useMediaQuery("(max-width: 48em)");
    const {isExperimental} = useExperimentalMode();

    // Show when: (mobile + sidebar hidden) OR (experimental + desktop + navbar collapsed)
    const showToggle =
        (isMobile && !mobileNavBarOpen) ||
        (isExperimental && !isMobile && !navbarExpanded);
    if (!showToggle) {
        return null;
    }

    return (
        <Flex
            style={{
                position: "absolute",
                top: 0,
                left: 0,
                zIndex: 1000,
            }}
        >
            <Tooltip label={t("common.openSidebar")}>
                <ActionIcon
                    color={color ?? "var(--dib-light-blue)"}
                    m="md"
                    size="lg"
                    radius="xl"
                    variant="white"
                    fw={400}
                    bg={bgColor ?? "var(--dib-brand-base)"}
                    title={t("common.openSidebar")}
                    onClick={toggleNavBar}
                >
                    <IconSidebar width={20} />
                </ActionIcon>
            </Tooltip>
        </Flex>
    );
};
